import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createNotificationTemplate } from "../../api/apiNotificationTemplates";
import parseError from "../../utils/parseError";

export const useCreateNotificationTemplate = () => {
    const queryClient = useQueryClient();

    const { mutate: createTemplateMutate, mutateAsync: createTemplateAsync, isPending: isCreating } = useMutation({
        mutationFn: createNotificationTemplate,
        onSuccess: (res) => {
            toast.success(res?.message || "Template created successfully");
            queryClient.invalidateQueries({ queryKey: ["notification-templates"] });
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to create template");
        },
    });

    return { createTemplateMutate, createTemplateAsync, isCreating };
};
